import { Status } from "ui/status";

import { getStatusType } from "components/partials/status-indicator/status-indicator.helpers";
import { type StatusIndicatorProps } from "components/partials/status-indicator/status-indicator.types";

// TODO: send for ARCHIVED_DRAFT status user friendly clientReviewStatusName as we need tit to show in table now
// TODO: rename clientReviewStatusName to description in dictionary to reuse StatusIndicator in other components
export const StatusIndicator = ({ versionStatuses, size, sx }: StatusIndicatorProps) => (
  <Status
    label={versionStatuses?.clientReviewStatusName || versionStatuses?.versionStatusName}
    size={size}
    sx={sx}
    type={getStatusType(versionStatuses?.status)}
  />
);
